import axios from 'axios'

import { ERROR_MESSAGE_DELETING } from '@/constants'
import { SilentCustomRequestError } from '@/helpers/requestErrors'
import { getLatestProductBundle, getShouldCreateProductBundle } from '@/selectors/product-bundles'
import { track, TRACK_PRODUCT_BUNDLE_START } from '@/trackers'

import { handleRequestError } from './request'

const CREATE_PRODUCT_BUNDLE = 'CREATE_PRODUCT_BUNDLE'
const CREATE_PRODUCT_BUNDLE_IF_NEEDED = 'CREATE_PRODUCT_BUNDLE_IF_NEEDED'
export const RECEIVE_PRODUCT_BUNDLE = 'RECEIVE_PRODUCT_BUNDLE'
export const REQUEST_PRODUCT_BUNDLE = 'REQUEST_PRODUCT_BUNDLE'
const ASSIGN_PRODUCT_BUNDLE_ACCOUNTANT = 'ASSIGN_PRODUCT_BUNDLE_ACCOUNTANT'
export const DELETE_PRODUCT_BUNDLE = 'DELETE_PRODUCT_BUNDLE'
export const REMOVE_PRODUCT_BUNDLE = 'REMOVE_PRODUCT_BUNDLE'

const createProductBundle = () => (dispatch, getState) => {
    dispatch({ type: CREATE_PRODUCT_BUNDLE })

    const { profile } = getState()
    const { id: userId } = profile

    return axios
        .post(`/productbundle/${userId}`)
        .then((response) => {
            track(TRACK_PRODUCT_BUNDLE_START)

            const responseData = response?.data || {}
            dispatch(receiveProductBundle({ item: responseData, fetchSuccessful: true }))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

export const createProductBundleIfNeeded = () => (dispatch, getState) => {
    dispatch({ type: CREATE_PRODUCT_BUNDLE_IF_NEEDED })

    const shouldCreateProductBundle = getShouldCreateProductBundle(getState())

    if (!shouldCreateProductBundle) {
        const latestProductBundle = getLatestProductBundle(getState())
        return Promise.resolve(latestProductBundle)
    }

    return dispatch(createProductBundle())
}

const receiveProductBundle = (data) => (dispatch) => {
    dispatch({ type: RECEIVE_PRODUCT_BUNDLE, data })
}

export const requestProductBundle =
    ({ productBundleId }) =>
    (dispatch) => {
        dispatch({ type: REQUEST_PRODUCT_BUNDLE, data: { productBundleId } })

        return axios
            .get(`/productbundle/${productBundleId}`)
            .then((response) => {
                const responseData = response?.data || {}
                dispatch(receiveProductBundle({ item: responseData, fetchSuccessful: true }))
                return responseData
            })
            .catch((error) => {
                if (error?.response?.status === 404) {
                    dispatch(receiveProductBundle({ fetchSuccessful: true }))
                }
                dispatch(handleRequestError(error))
            })
    }

export const assignProductBundleAccountant =
    (productBundleId, accountantId = '') =>
    (dispatch) => {
        dispatch({ type: ASSIGN_PRODUCT_BUNDLE_ACCOUNTANT })

        return axios
            .put(`/productbundle/${productBundleId}/accountant/${accountantId}`)
            .then((response) => {
                const productBundleModel = response?.data || {}

                const hasAssignAccountantError = !productBundleModel?.proposedAccountantId
                if (hasAssignAccountantError) return Promise.reject(new SilentCustomRequestError())

                dispatch(receiveProductBundle({ item: productBundleModel, fetchSuccessful: true }))

                return Promise.resolve()
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })
    }

export const deleteProductBundle = (productBundleId) => (dispatch) => {
    dispatch({ type: DELETE_PRODUCT_BUNDLE, productBundleId })

    return axios
        .delete(`/productbundle/${productBundleId}`)
        .then(() => {
            dispatch(removeProductBundle({ id: productBundleId }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING }))
            return Promise.reject(error)
        })
}

const removeProductBundle = (data) => (dispatch) => {
    dispatch({ type: REMOVE_PRODUCT_BUNDLE, data })
}
